// extracted by mini-css-extract-plugin
export default {"fullWidth":"zm-z","image":"Am-z","lazyLoadPicture":"Bm-z","lazyLoadSpinner":"Cm-z","lazyLoadSpin":"Dm-z","lazyLoadImage":"Em-z","hasStyledAspectRatio":"Fm-z"};